/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
// libraries
import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Query } from 'react-apollo';

import {
    object, string,
} from 'prop-types';
import mbpLogger from 'mbp-logger';
// components
import ProductDetailsPage from './index';

// helpers, redux, queries
import {
    getCurrencyData,
} from '../../../../../state/ducks/App/App-Selectors';
import { getBrand } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { GRAPHQL_ENV } from '../../../../gql';
import findProductPageByPartNumber from '../../../../gql/queries/findProductPageByPartNumber';
import GraphqlSeoHeadTags from '../../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const GraphqlProductDetailsPage = ({
    brand, currency, code,
}) => {
    const PLANT_GUIDE_PRODUCT_DETAILS_PAGE_QUERY = findProductPageByPartNumber(brand.domain, code, currency.currencyName);
    return (
        <Query query={PLANT_GUIDE_PRODUCT_DETAILS_PAGE_QUERY} fetchPolicy="cache-and-network">
            {({ data, error }) => {
                if (error) {
                    mbpLogger.logError({
                        query: PLANT_GUIDE_PRODUCT_DETAILS_PAGE_QUERY,
                        component: 'GraphqlProductDetailsPage.js',
                        message: 'Error executing findProductPageByPartNumber query',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data || !data?.findProductPageByPartNumber?.product) {
                    mbpLogger.logWarning({
                        query: PLANT_GUIDE_PRODUCT_DETAILS_PAGE_QUERY,
                        component: 'GraphqlProductDetailsPage.js',
                        message: 'No data returned for Plant Guide Product Details Page Query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                const pageData = data?.findProductPageByPartNumber;
                mbpLogger.logInfo({
                    message: 'data returned from collection page query',
                });

                const seoData = pageData?.content?.entries?.[0]?.seo || {};

                return (
                    <>
                        <GraphqlSeoHeadTags seoData={seoData} />
                        <ProductDetailsPage
                            data={pageData}
                        />
                    </>
                );
            }}
        </Query>
    );
};

GraphqlProductDetailsPage.propTypes = {
    brand: object.isRequired,
    currency: object.isRequired,
    code: string.isRequired,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
    currency: getCurrencyData(state),
});

const enhance = compose(
    withRouter,
    connect(mapStateToProps),
);

export default enhance(GraphqlProductDetailsPage);
